/** @module csi/heading/TagController */
define([
	"dojo/_base/declare",
	"src/c8-platform/type/value",
	"csi/_base/underscore",
	"csi/comm",
	"csi/reflection",
	"csi/heading/AggregateController",
	"csi/store/_base",
	"csi/service/writerService",
	"csi/xml"
], function(declare,{getListValueType}, _, comm, reflection, AggregateController, csiStore, {writeAggregateStoreOperation}, xml) {

	return declare(AggregateController, {
		/** custom request is used, so cannot hold changes */
		bHold: false,

		/**
		 * Override to prevent Go to Dialog option in drop-down
		 */
		_getActionViewParameters: function(ctx, h, ren) {
			return null;
		},

		/**
		 * this.oldValue is a map of 'tagName' -> 'tagURL'
		 * this.newValue is an array of existing 'tagURL'-s with an addition of new tag names.
		 * We need to compare values only.
		 */
		_isValueChanged: function() {
			var oldValues = _.values(this.oldValue);
			var newValues = this.newValue;
			if (!oldValues || !newValues) {
				return false;
			}
			return oldValues.length != newValues.length || _.difference(oldValues, newValues).length > 0;
		},

		/**
		 * Use custom operation to set tags on node
		 */
		_toWriterAttribute: function(id, type) {
			const {editNode,oldValue} = this;
			let { newValue } = this;
			var store = (editNode && editNode.store) || this.namesStore;
		
			if (_.isArray(newValue)) {
				newValue = newValue.filter( item => item != "");		
			}
		
			newValue = _.map(newValue , (url) => {
				const storeItem = store.get(url);
				if(storeItem.New) {
					var newTagUrl = comm.createUrl();
					this.m_writer.createNode(newTagUrl, "Tag", storeItem.Name);
					return newTagUrl;				
				} else {
					return url;
				}
			});
			
			const addedItems = newValue.filter(item => !oldValue.includes(item));
			const removedItems = oldValue.filter(item => !newValue.includes(item));

			writeAggregateStoreOperation(this.m_writer, store.aggregateStoreResponse, addedItems, removedItems);
			
			this.storeTag = store;
			this.bRefreshNode = true;
			this._notifyOfChange(null, this.getNode(), id);	
		},

		/**
		 * Refresh store
		 */
		postProcessSuccess: function () {
			var tagsMap = this.getNode()[this.heading.m_id];
			var results = _.map(tagsMap, function (value, key) {
				return csiStore.nameObject(key, value);
			});
			var store = this.storeTag;
			var q = {};
			q[store.newProperty] = true;
			store.query(q).forEach(function (item) {
				store.remove(store.getIdentity(item));
			});
			_.each(results, function (item) {
				if (!store.getFromMemory(store.getIdentity(item))) {
					store.put(item);
				}
			});
			this.inherited(arguments);
		},

		/**
		 * No custom validation for tag controller require so overriding onValidate of AggregateController with empty behavior
		 */
		onValidate() { }
	});
});
